import { Component, OnInit } from '@angular/core';
import { ApiService } from '@services/api/api.service';
import { IdentityAuthService } from '@services/identity-auth/identity-auth.service';
import { NbToastrService } from '@nebular/theme';
import { TreeNode, MenuItem, SelectItem } from 'primeng/api';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-directory-role-permissions',
  templateUrl: './directory-role-permissions.component.html',
  styleUrls: ['./directory-role-permissions.component.css']
})
export class DirectoryRolePermissionsComponent implements OnInit {
  loading: boolean = false;
  loadingSelected: boolean = false;
  allDirsLoaded: boolean = false;
  saving: boolean = false;
  directories: TreeNode[];
  includeNestedOptions: SelectItem[];
  roleId: any;
  public get entityId() { return this._entityId };
  public set entityId(value) {
    if (this._entityId == value)
      return;
    this.roleId = value; this.loadData();
  }
  public parent: any;

  protected _entityId: any;
  public expandedKeys: any = [];
  selectedDirectories: TreeNode[];
  constructor(private apiService: ApiService,
    private auth: IdentityAuthService,
    private messageService: NbToastrService,
    private route: ActivatedRoute) {
    this.auth.currentOrganisationIdObserver.subscribe(o => {
      this.loadData();
    });
  }

  ngOnInit() {

    this.includeNestedOptions = [
      { label: 'Include', value: true },
      { label: 'Exclude', value: false },
    ];


    //this.route.params.subscribe(params => {
    //  if (params.id && this.roleId != params.id) {
    //    this.roleId = params.id;
    //    this.loadData();
    //  }
    //})
    if (this.parent && this.parent.entityIdChange) {
      this.roleId = this.parent.entityId;
      this.parent.entityIdChange.subscribe(entityId => {
        this.entityId = entityId;
        this.roleId = entityId;
      })
    }
  }

  loadSelectedDirs() {
    this.loadingSelected = true;
    this.selectedDirectories = new Array();
    this.apiService.get(`/api/DirectoryStructureRole/directoriesForRole/${this.roleId}`)
      .subscribe(results => {
        results.forEach(o => {
          //this.selectNodeById(this.directories, o)
          this.expandedKeys = this.directories;
        })
        this.loadingSelected = false;
      }, err => {
        this.messageService.danger("Could not load", "Action");
        this.loadingSelected = false;
      });
  }

  loadData() {
    if (!this.allDirsLoaded) {
      this.apiService.get(`/api/DirectoryStructure/detailedList`)
        .subscribe(results => {
          this.directories = results;
          this.loading = false;
          this.allDirsLoaded = true;
          this.loadSelectedDirs();
        }, err => {
          this.messageService.danger("Could not load", "Action");
          this.loading = false;
        });
    }
    else this.loadSelectedDirs();


  }


  saveData() {
    this.saving = true;
    this.apiService.post(`/api/DirectoryStructureRole/setDirectoriesForRole/${this.roleId}`, {
      directoryStructureIds: this.selectedDirectories.map(o => {
        return o.data.id
      })
    })
      .subscribe(results => {

        this.saving = false;
      }, err => {
        this.messageService.danger("Could not save", "Action");
        this.saving = false;
      });
  }

  selectNodeById(directories: TreeNode[], id) {
    var nodeFound = false;
    if (!directories)
      return false;
    var filteredArr = directories.filter(o => o.data.id == id);
    if (filteredArr.length > 0) {
      this.selectedDirectories.push(filteredArr[0])
      return true;
    }
    else {
      directories.forEach(dir => {
        if (dir.children && !nodeFound) {
          if (this.selectNodeById(dir.children, id)) {
            nodeFound = true;
            return true;
          }
        }
      })
      return nodeFound;
    }
  }

  nodeSelect(event) {
    this.saveData();
  }
  nodeUnselect(event) {
    this.saveData();
  }

}
